/* tslint:disable */
import { Observable } from 'rxjs';
import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent } from '@angular/common/http';

import { BaseApiClient, RequestContext, ApiConfigManager, HttpRequestState } from '@sg/api/base-api-lib';
import { CompaniesApiConfig } from '../api-config';

import { CompaniesApi } from '../models';

@Injectable()
export class CompaniesApiClient extends BaseApiClient<CompaniesApiConfig> {
  constructor(httpClient: HttpClient, config: ApiConfigManager) {
    super(httpClient, config.companiesApiConfig);
  }

  companiesControllerGetCompaniesByid(
    params: { xSgUser?: string; id: string; extCompanyCode?: boolean },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<CompaniesApi.CompanyDto>;
  companiesControllerGetCompaniesByid(
    params: { xSgUser?: string; id: string; extCompanyCode?: boolean },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<CompaniesApi.CompanyDto>>;
  companiesControllerGetCompaniesByid(
    params: { xSgUser?: string; id: string; extCompanyCode?: boolean },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<CompaniesApi.CompanyDto>;
  companiesControllerGetCompaniesByid(
    params: { xSgUser?: string; id: string; extCompanyCode?: boolean },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<CompaniesApi.CompanyDto>>;
  companiesControllerGetCompaniesByid(
    params: { xSgUser?: string; id: string; extCompanyCode?: boolean },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<CompaniesApi.CompanyDto>>;
  companiesControllerGetCompaniesByid(
    params: { xSgUser?: string; id: string; extCompanyCode?: boolean },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<CompaniesApi.CompanyDto>>;
  companiesControllerGetCompaniesByid(
    params: { xSgUser?: string; id: string; extCompanyCode?: boolean },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    requestContext.queryParams = this.createQueryParams(['', 'extCompanyCode', params.extCompanyCode]);

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<CompaniesApi.CompanyDto>(
      `${this.basePath}/gateway/admin/companies/${this.encodeURI(String(params.id))}`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  companiesControllerPutCompaniesByid(
    params: { body?: CompaniesApi.CompanyDto; xSgUser?: string; id: string },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<CompaniesApi.CompanyDto>;
  companiesControllerPutCompaniesByid(
    params: { body?: CompaniesApi.CompanyDto; xSgUser?: string; id: string },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<CompaniesApi.CompanyDto>>;
  companiesControllerPutCompaniesByid(
    params: { body?: CompaniesApi.CompanyDto; xSgUser?: string; id: string },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<CompaniesApi.CompanyDto>;
  companiesControllerPutCompaniesByid(
    params: { body?: CompaniesApi.CompanyDto; xSgUser?: string; id: string },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<CompaniesApi.CompanyDto>>;
  companiesControllerPutCompaniesByid(
    params: { body?: CompaniesApi.CompanyDto; xSgUser?: string; id: string },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<CompaniesApi.CompanyDto>>;
  companiesControllerPutCompaniesByid(
    params: { body?: CompaniesApi.CompanyDto; xSgUser?: string; id: string },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<CompaniesApi.CompanyDto>>;
  companiesControllerPutCompaniesByid(
    params: { body?: CompaniesApi.CompanyDto; xSgUser?: string; id: string },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    this.verifyRequired(['id', params.id]);

    const consumes = ['application/json'];

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setContentTypeHeader(requestContext, ...consumes);

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.put<CompaniesApi.CompanyDto>(
      `${this.basePath}/gateway/admin/companies/${this.encodeURI(String(params.id))}`,
      params.body,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }

  companiesControllerGetCompanies(
    params?: { xSgUser?: string; isActive?: boolean; isDemo?: boolean; isSlTech?: boolean },
    options?: {
      observe?: 'bodyPromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<Array<CompaniesApi.CompanyDto>>;
  companiesControllerGetCompanies(
    params?: { xSgUser?: string; isActive?: boolean; isDemo?: boolean; isSlTech?: boolean },
    options?: {
      observe: 'responsePromise';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Promise<HttpResponse<Array<CompaniesApi.CompanyDto>>>;
  companiesControllerGetCompanies(
    params?: { xSgUser?: string; isActive?: boolean; isDemo?: boolean; isSlTech?: boolean },
    options?: {
      observe: 'body';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<Array<CompaniesApi.CompanyDto>>;
  companiesControllerGetCompanies(
    params?: { xSgUser?: string; isActive?: boolean; isDemo?: boolean; isSlTech?: boolean },
    options?: {
      observe: 'bodyWithState';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpRequestState<Array<CompaniesApi.CompanyDto>>>;
  companiesControllerGetCompanies(
    params?: { xSgUser?: string; isActive?: boolean; isDemo?: boolean; isSlTech?: boolean },
    options?: {
      observe: 'response';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpResponse<Array<CompaniesApi.CompanyDto>>>;
  companiesControllerGetCompanies(
    params?: { xSgUser?: string; isActive?: boolean; isDemo?: boolean; isSlTech?: boolean },
    options?: {
      observe: 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    }
  ): Observable<HttpEvent<Array<CompaniesApi.CompanyDto>>>;
  companiesControllerGetCompanies(
    params?: { xSgUser?: string; isActive?: boolean; isDemo?: boolean; isSlTech?: boolean },
    options: {
      observe?: 'responsePromise' | 'bodyPromise' | 'response' | 'body' | 'bodyWithState' | 'events';
      headers?: Array<[string, any]> | { [key: string]: any };
      reportProgress?: boolean;
      responseType?: 'json' | 'blob' | 'document' | 'arraybuffer';
    } = {}
  ): Promise<any> | Observable<any> {
    const requestContext: RequestContext = {};

    if (params) {
      requestContext.queryParams = this.createQueryParams(
        ['', 'isActive', params.isActive],
        ['', 'isDemo', params.isDemo],
        ['', 'isSLTech', params.isSlTech]
      );
    }

    requestContext.headers = this.createHeaders(options.headers || {}, ['x-sg-user', params.xSgUser]);

    this.setAcceptHeader(requestContext, 'application/json');

    this.setApiKeySecurity('Authorization', 'header', requestContext);

    const baseOptions = this.createClientOptions(requestContext, options);
    const obs$ = this.httpClient.get<Array<CompaniesApi.CompanyDto>>(
      `${this.basePath}/gateway/admin/companies`,
      <any>Object.assign(baseOptions, {})
    );

    if (options.observe === 'bodyWithState') {
      return this.toHttpRequestState(obs$);
    }

    return !options.observe || options.observe.endsWith('Promise') ? this.toPromise(obs$) : obs$;
  }
}
